import { BATCH_DROPDOWN, GET_USER_DATA, LOGIN_ADMIN, LOGIN_SUCCESS, LOGOUT_SUCCESS, MASTER_DASHBOARD, PATIENT_DROPDOWN, SEND_OTP } from "../actions/Admin.action";

const initialState = {
    LoginAdmin: '',
    isAuthenticated: localStorage.getItem('isAuthenticated') === 'true',
    SendOtp: '',
    masterCount: '',
    getUserData: '',
    batchDropdown: '',
    patientDrodown: ''
}

const adminReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_ADMIN:
            return { ...state, LoginAdmin: action.payload };
        case LOGIN_SUCCESS:
            return { ...state, isAuthenticated: true };
        case LOGOUT_SUCCESS:
            return { ...state, isAuthenticated: false };
        case SEND_OTP:
            return { ...state, SendOtp: action.payload };
        case MASTER_DASHBOARD:
            return { ...state, masterCount: action.payload };
        case GET_USER_DATA:
            return { ...state, getUserData: action.payload };
        case BATCH_DROPDOWN:
            return { ...state, batchDropdown: action.payload };
        case PATIENT_DROPDOWN:
            return { ...state, patientDrodown: action.payload };
        default:
            return state;
    }
}

export default adminReducer;